import { gql } from "apollo-boost"

export const getValorationByOwnerAndSubmission = gql`
query getValorationByOwnerAndSubmission($submission: ID!, $owner: ID!){ 
  Valoration:ValorationByOwnerAndSubmission(submission: $submission, owner: $owner){
    id
    createdAt
    modifiedAt
    val
    comment
    owner {
      id
      displayName
      email
      uid
    }
  }
}
`